import alt, { AltStoreModel } from '../components/alt';
import LocalesActions from './locales_actions';
import I18n from 'i18n-js';

const AVAILABLE_LOCALES = ['en', 'de', 'es', 'fr', 'nl', 'ja', 'it'];
const UK_LOCALE = 'en_gb';
const DEFAULT_LOCALE = I18n.defaultLocale;

class LocalesStore extends AltStoreModel {
  constructor() {
    super();
    this.resetState();

    this.bindListeners({
      handleCurrentLocaleChange: LocalesActions.SET_CURRENT_LOCALE,
      handleShowUkLocaleChange: LocalesActions.SET_SHOW_UK_LOCALE,
    });
  }

  handleCurrentLocaleChange(locale) {
    this.currentLocale = locale;
  }

  handleShowUkLocaleChange(showUkLocale) {
    this.showUkLocale = !!showUkLocale;
    if (this.showUkLocale) {
      this.locales = [...AVAILABLE_LOCALES, UK_LOCALE];
    } else {
      this.locales = AVAILABLE_LOCALES;
    }
  }

  resetState() {
    this.locales = AVAILABLE_LOCALES;
    this.currentLocale = DEFAULT_LOCALE;
    this.showUkLocale = false;
  }
}

export default alt.createStore(LocalesStore, 'LocalesStore');
